import styled from 'styled-components';
import { color, fontSize, fontWeight, spacing } from '../../../theme';

export const StyledWherePerks = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

export const StyledWherePerksItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 14rem;
  margin: ${spacing('xs')} ${spacing('md')};
  color: ${color('text_subtle')};
  font-weight: ${fontWeight('medium')};
`;

export const StyledWherePerksItemIcon = styled.img`
  display: block;
  width: ${spacing('xl3')};
  height: ${spacing('xl3')};
  margin-bottom: ${spacing('xs')};
`;

export const StyledWherePerksItemTitle = styled.h4`
  font-size: ${fontSize('xs')};
  line-height: 1;
  font-weight: ${fontWeight('black')};
  text-transform: uppercase;
  margin-top: 0;
  margin-bottom: ${spacing('xs2')};
  color: ${color('text_default')};
`;
